import React from 'react';
import { EditButton, useRecordContext, TopToolbar } from 'react-admin';
import config from 'config';
import { ENUMS } from 'components/Enum/enums';
import CopyLink from 'components/CopyLink';
import ApprovalButton from './ApprovalButton';
import AvailableProfessionalsSearch from 'components/AvailableProfessionalsSearch';
import { CreateTestJobButton } from './CreateTestJobButton';
import useGate from 'hooks/useGate';
import { gateNames } from 'constants/statsig';

const JobShowActions = () => {
  const record = useRecordContext();
  const { value: blockPostShifts } = useGate(gateNames.blockPostShifts);
  const showApprovalButton = record?.status === 'held_for_dispute_review';

  return (
    <TopToolbar>
      {[ENUMS.Job.status.active].includes(record?.status) && (
        <CopyLink textToCopy={`${config.rails_url}/dashboard/jobs/${record.id}`} />
      )}
      {!config.is_production && [ENUMS.Job.status.active].includes(record?.status) && (
        <AvailableProfessionalsSearch />
      )}
      <CreateTestJobButton />
      {blockPostShifts ? null : showApprovalButton ? (
        <ApprovalButton />
      ) : (
        <EditButton data-testid="edit-button" />
      )}
    </TopToolbar>
  );
};

export default JobShowActions;
